// @ts-check
import { addUnitType, deleteUnitType } from './UnitsTypes'
import { buildingType } from '../../common/constants'
import { LOCATIONS } from '../common/locations-dropdown';
import locations from '../../../testdata/locations.json';
import { v4 as uuidv4 } from 'uuid';

import {
  SET_PROJECT_NAME,
  SET_LOCATION,
  SET_COUNTRY,
  SET_UNITS,
  SET_PLOT_LENGTH,
  SET_MINIMAL_BLOCK_DEPTH,
  SET_MINIMAL_BLOCK_WIDTH,
  SET_PLOT_WIDTH,
  SET_BUILDING_TYPE,
  SET_FLOOR_HEIGHT,
  SET_DISTANCE_FROM_ROAD,
  SET_ROAD_WIDTH,
  SET_FLOORS_NUMBER,
  SET_PERPENDICULAR_FLOORS_NUMBER,
  SET_CORRIDOR_WIDTH,
  SET_FLAT_DEPTH,
  SET_DISTANCE_BETWEEN_VERTICAL_CORES,
  SET_UNIT_TYPE,
  SET_MIX_BY,
  SET_MIXER_VALS,
  ADD_UNIT_TYPE,
  DELETE_UNIT_TYPE,
  SET_FORM_QUERY_SENT,
  SOLUTIONS_ARRIVED
} from '../../../redux/actions/actionTypes';

const initialState = {
  query_in_flight: false,
  project_name: "test-project",
  country: "United Kingdom",
  location: "UNITED-KINGDOM_LONDON",
  units: 'm',
  building_type: buildingType.I,
  floors_number: 5,
  floors_number_perpendicular: 5,
  floor_height: 3.0,
  distance_from_road: 3,
  road_width: 4,
  flat_depth: 5,
  total_building_width: 300,
  corridor_width: 2,
  distance_between_vertical_cores: 20,
  plot_width: 100,
  plot_length: 50,
  minimal_block_depth: 10,
  minimal_block_width: 10,
  mix_by: 'AREA',
  unit_types: addUnitType([], 'm')
}

function buildingInfoReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FORM_QUERY_SENT:
      return {
        ...state,
        query_in_flight: true
      }
    case SOLUTIONS_ARRIVED:
      return {
        ...state,
        query_in_flight: false
      }
    case SET_PROJECT_NAME:
      return {
        ...state,
        project_name: action.payload
      }
    case SET_LOCATION:
      debugger;
      return {
        ...state,
        location: action.payload,
      }
    case SET_COUNTRY:
      debugger;
      let x = LOCATIONS.filter(r => r.val.includes(action.payload))
      let key = x[0].key
      return {
        ...state,
        country: action.payload,
        location: key,

      }
    case SET_UNITS:
      return {
        ...state,
        units: action.payload,
        plot_width: action.payload == 'm' ? 100 : 300,
        plot_length: action.payload == 'm' ? 50 : 150,

        floor_height: action.payload == 'm' ? 3 : 11,
        // core_distance: action.payload == 'm' ? 20 : 70,
        distance_between_vertical_cores: action.payload == 'm' ? 20 : 70,
        flat_depth: action.payload == 'm' ? 5 : 16,
        minimal_block_depth: action.payload == 'm' ? 10 : 35,
        minimal_block_width: action.payload == 'm' ? 10 : 50,
        // floor_height: action.payload == 'm' ? 3 : 10
        road_width: action.payload == 'm' ? 4 : 10,
        distance_from_road: action.payload == 'm' ? 3 : 7,
        unit_types: action.payload == 'm' ? [
          {
            "id": uuidv4(),
            "name": "A",
            "color": "#e53935",
            "floor_area": 50,
            "unit_type": "Unit m9",
            "storeys": 2,
            "house_width": 7,
            "cost_sqr_meter": 1000,
            "revenue_sqr_meter": 1000,
            "mixerVal": 100
          }
        ] : [
          {
            "id": uuidv4(),
            "name": "A",
            "color": "#e53935",
            "floor_area": 500,
            "unit_type": "Unit m9",
            "storeys": 2,
            "house_width": 23,
            "cost_sqr_meter": 1000,
            "revenue_sqr_meter": 1000,
            "mixerVal": 100
          }
        ],
      }
    case SET_PLOT_WIDTH:
      return {
        ...state,
        plot_width: action.payload
      }
    case SET_PLOT_LENGTH:
      return {
        ...state,
        plot_length: action.payload
      }
    case SET_MINIMAL_BLOCK_DEPTH:
      return {
        ...state,
        minimal_block_depth: action.payload
      }
    case SET_MINIMAL_BLOCK_WIDTH:
      return {
        ...state,
        minimal_block_width: action.payload
      }
    case SET_BUILDING_TYPE:
      return {
        ...state,
        building_type: action.payload
      }
    case SET_FLOOR_HEIGHT:
      return {
        ...state,
        floor_height: action.payload
      }
    case SET_DISTANCE_FROM_ROAD:
      return {
        ...state,
        distance_from_road: action.payload
      }
    case SET_ROAD_WIDTH:
      return {
        ...state,
        road_width: action.payload
      }
    case SET_FLOORS_NUMBER:
      return {
        ...state,
        floors_number: action.payload
      }

    case SET_PERPENDICULAR_FLOORS_NUMBER:
      return {
        ...state,
        floors_number_perpendicular: action.payload
      }

    case SET_CORRIDOR_WIDTH:
      return {
        ...state,
        corridor_width: action.payload
      }
    case SET_FLAT_DEPTH:
      return {
        ...state,
        flat_depth: action.payload
      }
    case SET_DISTANCE_BETWEEN_VERTICAL_CORES:
      return {
        ...state,
        distance_between_vertical_cores: action.payload
      }
    case SET_MIX_BY:
      return {
        ...state,
        mix_by: action.payload
      }
    case ADD_UNIT_TYPE: {
      const updatedUnitTypes = addUnitType(state.unit_types, state.units)
      return {
        ...state,
        unit_types: updatedUnitTypes
      }
    }
    case DELETE_UNIT_TYPE: {
      if (state.unit_types.length === 1) {
        return {
          ...state
        }
      }
      const unitIdToDelete = action.payload
      const updatedUnitTypes = deleteUnitType(state.unit_types, unitIdToDelete)
      return {
        ...state,
        unit_types: updatedUnitTypes
      }
    }
    case SET_UNIT_TYPE: {
      const unitTypeId = action.payload.id
      const updatedUnitTypes = state.unit_types.map(ut => {
        return ut.id === unitTypeId ? action.payload : ut
      })
      return {
        ...state,
        unit_types: updatedUnitTypes
      }
    }
    case SET_MIXER_VALS: {
      const splitterVals = action.payload
      const updatedUnitTypes = state.unit_types.map(ut => ut)
      let prev = 0
      for (let i = 0; i < splitterVals.length; i++) {
        const splitter = splitterVals[i]
        let val = splitter - prev
        prev = splitter
        updatedUnitTypes[i].mixerVal = val
      }

      updatedUnitTypes[updatedUnitTypes.length - 1].mixerVal = 100 - prev

      return {
        ...state,
        unit_types: updatedUnitTypes
      }
    }

    default:
      return state;
  }
}

export default buildingInfoReducer